<div class="assistant-box">
    <!-- 图标 -->
    <svg *ngIf="!openStatus && showIcon" id="smart-assistant-switch-icon"
        class="assistant-box-icon" [nTooltip]="tooltip" (click)="statusChange()">
        <use xlink:href="#app-icon-smart-assistant-switch"></use>
    </svg>
    <!-- 图标后的文字 -->
    <span *ngIf="content" class="assistant-box-font-style" [class.ml-8]="showIcon"
        [ngStyle]="{'font-size': isTitle ? '0.18rem' : '0.16rem' }">
        {{content}}
    </span>
</div>
